import { Diamond } from "lucide-react";

const BRANDS = [
    "BMW Service",
    "Mercedes-Benz",
    "Porsche",
    "Audi",
    "Lexus",
    "Ford",
    "Chevrolet",
    "Toyota",
    "Honda",
    "Nissan",
];

export const Marquee = () => (
    <section
        data-testid="marquee-section"
        className="overflow-hidden border-y border-white/10 bg-[#0C1019] py-12"
    >
        <p className="mb-9 text-center font-mono text-xs uppercase tracking-[0.3em] text-slate-500">
            Honored at franchise service departments
        </p>
        <div className="marquee-track flex w-max items-center">
            {[...BRANDS, ...BRANDS].map((brand, i) => (
                <span key={`${brand}-${i}`} className="flex items-center">
                    <span
                        className={`whitespace-nowrap px-8 font-display text-3xl font-extrabold uppercase tracking-tight md:text-5xl ${
                            i % 2 === 0 ? "text-white/30" : "text-white/[0.08]"
                        }`}
                    >
                        {brand}
                    </span>
                    <Diamond className="h-4 w-4 shrink-0 text-sky-500/50" />
                </span>
            ))}
        </div>
    </section>
);
